import { useState, useEffect } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const SELLER_BRANDING_TEST_NAME = 'PDP_SellerBranding_April2026';

export const useIsSellerBrandingTestVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);

    useEffect(() => {
        setIsVariant(getAbTestV2(SELLER_BRANDING_TEST_NAME)?.variant === 'variant');
    }, []);

    return isVariant;
};

export const useTrackSellerBrandingTest = (): void => {
    useEffect(() => {
        trackAbTestV2Variant(SELLER_BRANDING_TEST_NAME);
    }, []);
};
